import PropTypes from 'prop-types'
import React, { useEffect, useRef } from 'react'
import { useTranslation } from 'react-i18next'
import { useDispatch } from 'react-redux'
import { reset } from 'redux-form'
import styled from 'styled-components/macro'

import { media } from 'utilities/styled'
import { scrollTo } from 'utilities/utils'

import { clearData } from 'redux/actions/data'

import LoadingIndicator from 'components/atoms/loading-indicator'
import EnhancedCard from 'components/layouts/enhanced-card'
import CarVersionSelector from 'components/organisms/car-version-selector'
import PageHeader from 'components/organisms/page-header'

import CarVersionSearch from 'components/organisms/car-version-search'
import { mapCarFileType } from 'utilities/mapping'

const Container = styled.div`
  background: ${({ theme }) => theme.colors.brandFoxtrot};
  padding: 0 ${({ theme }) => theme.sizings.lvl3};

  ${media.desktop`
    padding: 0 60px;
  `};
`

const ContentContainer = styled(EnhancedCard)`
  margin: 0 -${({ theme }) => theme.sizings.lvl3} ${({ theme }) =>
      theme.sizings.lvl3} -${({ theme }) => theme.sizings.lvl3};
  ${media.tablet`
    margin: 0 0 ${({ theme }) => theme.sizings.lvl3} 0;
  `};
`

function CarEntryStep1NoLicense({
  addNewCarData,
  car,
  editions,
  getEditions,
  newCar,
  carFileId,
}) {
  const { t } = useTranslation()
  const extraFilters = useRef()
  const editionsData = editions && editions.data
  const loading = editions && editions.loading
  const dispatch = useDispatch()

  // clear initial form when restarting this process:
  useEffect(() => {
    clearData('entryNoLicense')
    dispatch(reset('entryNoLicense'))
  }, [dispatch])

  useEffect(() => {
    if (editionsData && extraFilters.current) {
      scrollTo(extraFilters.current)
    }
  }, [editionsData])

  return (
    <Container>
      <PageHeader
        mainTitle={mapCarFileType(t, car?.voertuigsoort_mapped)}
        status={t('entry')}
        subTitle={t('step12SearchCar')}
      />
      <ContentContainer>
        <CarVersionSearch isEnrichment carFileId={carFileId} car={car} />
      </ContentContainer>

      <div ref={extraFilters}>
        {loading && <LoadingIndicator height="100px" />}
        {editionsData && car && (
          <ContentContainer data-test-e2e="car-version-selector">
            <CarVersionSelector
              addNewCarData={addNewCarData}
              car={car}
              carFileId={carFileId}
              editions={editionsData}
              getEditions={getEditions}
              newCar={newCar}
              isEnrichment
            />
          </ContentContainer>
        )}
      </div>
    </Container>
  )
}

CarEntryStep1NoLicense.propTypes = {
  addNewCarData: PropTypes.func.isRequired,
  car: PropTypes.object,
  getEditions: PropTypes.func.isRequired,
  editions: PropTypes.object,
  newCar: PropTypes.object,
  carFileId: PropTypes.string.isRequired,
}

CarEntryStep1NoLicense.defaultProps = {
  car: null,
  editions: null,
  newCar: null,
}

export default CarEntryStep1NoLicense
